import {useState} from "react";
import {kSystemIcons} from "../../../../constants/icons";
import {isNumberKeyDisabled} from "../../../../controllers/games/MultiplicationGameController";

export default function MultiplicationKeyItem({item, userAnswer, onKeyPressed}) {
    // Used in MultiplicationGameKeyboard to display one single
    // key for the specific multiplication game

    // PROPERTIES
    const [isHovered, setIsHovered] = useState(false)

    // BUILD
    return (
        <div className={`${renderKeyItemStyle(item, userAnswer, isHovered)} h-[64px] min-h-[64px] flex justify-center items-center rounded-[8px]`}
             onMouseEnter={() => setIsHovered(true)}
             onMouseLeave={() => setIsHovered(false)}
             onClick={() => {onKeyPressed(item, userAnswer)}}>
            {renderKeyComponent(item)}
        </div>
    );

    // METHODS
    // ---- Render key item style
    function renderKeyItemStyle(item, userAnswer, isHovered) {
        if (item === "Erase") {
            return isEraseKeyItemDisabled(userAnswer)
                ? 'cursor-not-allowed bg-disabledBlue border-disabledBorder border-[1px] text-greyLight7'
                : isHovered
                    ? 'cursor-pointer bg-blueBackground border-[1px] border-timerBlue text-white'
                    : 'bg-timerViolet border-[1px] border-violetGrey text-white'
        } else if (item === "-/+") {
            return 'cursor-not-allowed bg-disabledBlue border-disabledBorder border-[1px] text-greyLight7'
        } else {
            return isNumberKeyDisabled(userAnswer)
                ? 'cursor-not-allowed bg-disabledBlue border-disabledBorder border-[1px] text-greyLight7'
                : isHovered
                    ? 'cursor-pointer bg-blueBackground border-[1px] border-timerBlue text-white'
                    : 'bg-timerViolet border-[1px] border-violetGrey text-white'
        }
    }

    // ---- Render key component
    function renderKeyComponent(item) {
        // Prepare
        if (item === "Erase") {
            return <i className={"material-icons text-[24px]"}>
                {kSystemIcons.erase}
            </i>
        }
        if (item === "-/+") {
            return <span className={"font-medium text-[24px] pb-[3px]"}>
                {item}
            </span>
        }
        // Return
        return <span className={"font-medium text-[24px]"}>
                {item}
        </span>
    }

    // ---- Is erase key item disabled
    function isEraseKeyItemDisabled(userAnswer) {
        return userAnswer.length === 0
    }

}
